import { Component } from '@theme/component';
import { debounce } from '@theme/utilities';

/**
 * A custom element that allows the user to clean a search input.
 *
 * @typedef {object} Refs
 * @property {HTMLInputElement} searchPageInput - The search input element.
 * @extends {Component<Refs>}
 */
class SearchPageInputComponent extends Component {
  requiredRefs = ['searchPageInput'];

  /**
   * Handles the keydown event on the search input and resets the search when
   * empty and Escape is pressed.
   *
   * @param {KeyboardEvent} event - The keyboard event.
   */
  handleKeyDown = debounce((event) => {
    const value = this.refs.searchPageInput.value.trim();

    if (event.key === 'Escape' && value === '') {
      this.#submitEmptySearch();
    }
  }, 100);

  #submitEmptySearch() {
    const searchInput = this.refs.searchPageInput;

    searchInput.focus();
    searchInput.value = '';

    if (this.#isEmptyState()) return;

    searchInput.form?.submit();
  }

  #isEmptyState = () => {
    const url = new URL(window.location.href);
    const queryParam = url.searchParams.get('q') ?? '';

    return queryParam.trim() === '';
  };
}
// Interceptar submit para búsqueda exacta por número de parte
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('form').forEach(function(form) {
    const action = form.getAttribute('action') || '';
    if (!action.includes('search')) return;
    
    form.addEventListener('submit', function(e) {
      const input = form.querySelector('input[name="q"]');
      if (!input) return;
      
      const val = input.value.trim();
      
      if (!/\d{4,}/.test(val)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        input.value = '';
        alert('Por favor ingresa un número de parte válido (mínimo 4 dígitos).');
        return;
      }
      
      const valNorm = val.replace(/[-./]/g, '');
      input.value = '"' + val + '" OR "' + valNorm + '"';
    }, true);
  });
});


if (!customElements.get('search-page-input-component')) {
  customElements.define('search-page-input-component', SearchPageInputComponent);
}
